import { StandardProps } from "../componentMap";

export type OptionsType = {
  isSelected: boolean;
  url: string;
  name: string;
  selectorTitle: string;
  selectorValue: string;
}[];

type ProductRange = {
  brand: string;
  range: string;
  sku: string;
  model: string;
  screenSize: string;
  size: string;
  pimId: string;
  url: string;
  selectorTitle: string;
  selectorValue: string;
}[];

export function getOptionsList(
  product: StandardProps["product"],
  productsRange: Record<string, ProductRange>,
  sellingProductTypes: string[],
): OptionsType {
  const sellingProductType = product?.sellingProductType;
  if (
    !sellingProductType ||
    !sellingProductTypes.includes(sellingProductType)
  ) {
    return [];
  }

  const productArray = productsRange[sellingProductType];
  if (!productArray) {
    return [];
  }

  return productArray
    .filter((item) => {
      const attrs = product?.attributes ?? [];
      const variantAttrs = product?.variants?.[0]?.attributes ?? [];
      return (
        attrs.some((attr) => attr.values.includes(item.range)) ||
        variantAttrs.some((attr) => attr.values.includes(item.range))
      );
    })
    .map((item) => ({
      isSelected:
        product?.attributes?.some((attr) =>
          JSON.stringify(attr.values).includes(item.screenSize),
        ) ?? false,
      url: item.url,
      name: String(item.size),
      selectorTitle: String(item.selectorTitle),
      selectorValue: String(item.selectorValue),
    }));
}
